












import { Component, Vue, Prop } from 'vue-property-decorator'
import { EventBus, EventBusEvents } from '../system/eventbus'

@Component({})
export default class GlobalWaveform extends Vue {
  @Prop()
  url: string

  @Prop()
  name: string

  get playing(): boolean {
    return this.$store.state.player.url === this.url && this.$store.state.player.url !== null
  }

  play() {
    EventBus.$emit(EventBusEvents.GlobalWaveformStart, {
      url: this.url,
      name: this.name
    })
  }
}
